import DoubleInput from "@/Layouts/components/InputComponents/DoubleInput";
import { Stack } from "@mui/material";
import { CSSProperties, FC, useMemo } from "react";
import {
	INPUT_SX,
	MANAGER_DECIMALS,
	MANAGER_POSITION,
	PERCENT_DECIMALS,
	PERCENT_INPUT_TYPE,
	PERCENT_MAX,
	PERCENT_MIN,
	UNIT_DECIMALS,
	UNIT_INPUT_TYPE,
	UNIT_MAX,
	UNIT_MIN,
} from "./constants";
import { IBonus } from "./types";
import { isInfinityValue } from "./utils";

interface MatrixColumnCellProps {
	index: number;
	item: IBonus;
	errors?: any[];
	readOnly?: boolean;
	position?: string;
	sx?: CSSProperties;
	onActionUpdate: (...args: any[]) => void;
	onChangeType: (...args: any[]) => void;
}

const MatrixColumnCell: FC<MatrixColumnCellProps> = (props) => {
	const { index, item, errors = [], sx = INPUT_SX, readOnly = false, position = "", onActionUpdate, onChangeType } = props;

	const unitDecimals = useMemo(() => {
		return position === MANAGER_POSITION ? MANAGER_DECIMALS : UNIT_DECIMALS;
	}, [position]);

	const isFirstInfinity = isInfinityValue(+item?.from?.value);
	const isSecondInfinity = isInfinityValue(+item?.to?.value);

	return (
		<Stack>
			<DoubleInput
				firstInput={{
					data: [
						{
							type: PERCENT_INPUT_TYPE,
							min: PERCENT_MIN,
							max: PERCENT_MAX,
							decimals: PERCENT_DECIMALS,
							decimalsEditable: true,
							dashed: isFirstInfinity,
						},
						{
							type: UNIT_INPUT_TYPE,
							min: UNIT_MIN,
							max: UNIT_MAX,
							decimals: unitDecimals,
							decimalsEditable: !!unitDecimals,
							dashed: isFirstInfinity,
						},
					],
					value: item?.from?.value || 0,
					defaultType: item?.from?.input || PERCENT_INPUT_TYPE,
					disabled: readOnly || isFirstInfinity,
					error: Boolean(errors?.[index]?.from),
					sx,
					onActionUpdate: (value: any) => {
						onActionUpdate(0, index, "column", "from", value);
					},
					onChangeType: (_: any, input: any) => {
						onChangeType(0, index, "column", "from", input);
					},
					readOnly: true,
				}}
				secondInput={{
					data: [
						{
							type: PERCENT_INPUT_TYPE,
							min: PERCENT_MIN,
							max: PERCENT_MAX,
							decimals: PERCENT_DECIMALS,
							decimalsEditable: true,
							dashed: isSecondInfinity,
						},
						{
							type: UNIT_INPUT_TYPE,
							min: UNIT_MIN,
							max: UNIT_MAX,
							decimals: unitDecimals,
							decimalsEditable: !!unitDecimals,
							dashed: isSecondInfinity,
						},
					],
					value: item?.to?.value || 0,
					defaultType: item?.to?.input || PERCENT_INPUT_TYPE,
					disabled: readOnly || isSecondInfinity,
					error: Boolean(errors?.[index]?.to),
					sx,
					onActionUpdate: (value: any) => {
						onActionUpdate(0, index, "column", "to", value);
					},
					onChangeType: (_: any, input: any) => {
						onChangeType(0, index, "column", "to", input);
					},
				}}
			/>
		</Stack>
	);
};

export default MatrixColumnCell;
